import { render, staticRenderFns } from "./UserPanels.vue?vue&type=template&id=1cfc4267&scoped=true&"
import script from "./UserPanels.vue?vue&type=script&lang=js&"
export * from "./UserPanels.vue?vue&type=script&lang=js&"
import style0 from "./UserPanels.vue?vue&type=style&index=0&id=1cfc4267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc4267",
  null
  
)

export default component.exports